export default __webpack_public_path__ + "static/media/bg04.be4c5a66.jpg";